import { ICountrysideBuildersCallbackProps } from '@cian/frontend-builders-callback-widget';
import { TDeviceType, useDeviceType } from '@cian/ui-kit';
import { useMemo } from 'react';
import { ECallbackWidgetPlacement } from '../types/callbackWidget';

export type TButtonProps = Partial<Record<TDeviceType, ICountrysideBuildersCallbackProps['buttonProps']>>;

export const HEAD_BUTTON_PROPS: TButtonProps = {
  desktop: { theme: 'fill_white_primary' },
};

export const HOUSE_GALLERY_BUTTON_PROPS: TButtonProps = {
  desktop: { theme: 'fill_secondary', size: 'XS' },
  tablet: { theme: 'fill_secondary', size: 'XS' },
  phone: { theme: 'fill_primary', text: 'Консультация', size: 'L' },
};

export const FEEDBACK_BUTTON_PROPS: TButtonProps = {
  tablet: { theme: 'fill_secondary' },
  phone: { theme: 'fill_secondary' },
};

export const CONTACTS_BUTTON_PROPS: TButtonProps = {
  desktop: { theme: 'fill_white_primary' },
};

export const useCallbackButtonProps = (
  placement: ECallbackWidgetPlacement,
): ICountrysideBuildersCallbackProps['buttonProps'] => {
  const deviceType = useDeviceType();

  return useMemo(() => {
    switch (placement) {
      case ECallbackWidgetPlacement.Head:
        return HEAD_BUTTON_PROPS[deviceType];

      case ECallbackWidgetPlacement.HouseGallery:
        return HOUSE_GALLERY_BUTTON_PROPS[deviceType];

      case ECallbackWidgetPlacement.Feedback:
        return FEEDBACK_BUTTON_PROPS[deviceType];

      case ECallbackWidgetPlacement.Contacts:
        return CONTACTS_BUTTON_PROPS[deviceType];

      default:
        return;
    }
  }, [deviceType, placement]);
};
